import {createContext, useContext, useEffect, useState} from "react";
import {
    GoogleAuthProvider,
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signInWithPopup,
    signOut
} from 'firebase/auth';
import {auth} from '../config/firebase';
import {User, UserCredential} from "@firebase/auth/dist/auth-public";
import {GlobalStateContext} from "./GlobalContext";
import { useAtom, useAtomValue } from "jotai";
import {userAtom} from "./auth_atoms";


//User login credentials and functionality

type UserAuthContextType = {
    // user: User | undefined | null
    user: Partial<User>
    logout: () => Promise<void>
    signInEmailPassword: (email: string, password: string) => Promise<UserCredential>
    signInWithGoogle: () => Promise<UserCredential>
}

const UserAuthContext = createContext<UserAuthContextType>({
    user: null,
    logout: () => new Promise<void>(() => false),
    signInEmailPassword: (email, password) => new Promise<UserCredential>(() => false),
    signInWithGoogle: () => new Promise<UserCredential>(() => false),
})

export const UserAuthContextProvider = ({children}: any) => {
    const {authorizing, setAuthorizing} = useContext(GlobalStateContext);
    const [user, setUser] = useAtom(userAtom);

    const signInWithGoogle = () => {
        const provider = new GoogleAuthProvider();
        return signInWithPopup(auth, provider)
    };


    const signInEmailPassword = (email: string, password: string) => {
        return signInWithEmailAndPassword(auth, email, password)
    }

    const logout = () => {
        return signOut(auth)
    }

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            // console.log(currentUser);
            setUser(currentUser);
        });
        return () => {
            unsubscribe();
        };
    }, []);


    return (
        <UserAuthContext.Provider
            // value={{user, logout, signInEmailPassword, signInWithGoogle, permissions, roles, can, is}}>
            value={{user, logout, signInEmailPassword, signInWithGoogle}}>
            {children}
        </UserAuthContext.Provider>
    )
}

export const UserAuth = () => {
    return useContext(UserAuthContext)
}